<div class="flex flex-col w-full h-full justify-center items-center text-white bg-secondary-800">
	<div class="text-4xl">{{ 'summary.summary_of_the_year' | translate }}</div>
	<div class="text-[300px] leading-none font-bold">{{ year() }}</div>
	<ui-button
		class="mt-6"
		type="secondary"
		[text]="'general.download' | translate"
		icon="media_png"
		iconSize="xl"
		styleClass="h-auto text-2xl! text-white! border-white"
		(buttonClicked)="downloadPNG()"
		directivePlausible
		eventName="click: download-png"
		eventLabel="summary-of-the-year-download-png"
	></ui-button>
</div>
